/* Prayasa: product card image browsing.
   Desktop (hover-capable): pointer position across the image swaps slides.
   Touch: swipe left/right, or tap the left/right edge zones.
   Delegated + idempotent, so it also covers cards injected after load. */
(function(){
  var HOVER = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function slidesOf(media){ return media.querySelectorAll('[data-pcard-slide]'); }
  function dotsOf(media){ return media.querySelectorAll('[data-pcard-dot]'); }

  function show(media, i){
    var s = slidesOf(media), d = dotsOf(media);
    if(!s.length) return;
    if(i < 0) i = s.length - 1;
    if(i >= s.length) i = 0;
    var cur = parseInt(media.getAttribute('data-pcard-i') || '0', 10);
    if(cur === i && media.hasAttribute('data-pcard-i')) return;
    for(var k=0;k<s.length;k++){ s[k].classList.toggle('pcard__slide--on', k === i); }
    for(var j=0;j<d.length;j++){ d[j].classList.toggle('pcard__dot--on', j === i); }
    media.setAttribute('data-pcard-i', i);
  }

  function step(media, delta){
    var n = slidesOf(media).length;
    if(n < 2) return;
    var cur = parseInt(media.getAttribute('data-pcard-i') || '0', 10);
    show(media, (cur + delta + n) % n);
  }

  // Desktop: map horizontal pointer position to a slide index.
  if(HOVER){
    document.addEventListener('mousemove', function(e){
      var media = e.target.closest && e.target.closest('[data-pcard-media]');
      if(!media) return;
      var n = slidesOf(media).length;
      if(n < 2) return;
      var r = media.getBoundingClientRect();
      if(!r.width) return;
      var p = (e.clientX - r.left) / r.width;
      if(p < 0) p = 0; if(p > 0.999) p = 0.999;
      show(media, Math.floor(p * n));
    }, { passive:true });

    document.addEventListener('mouseleave', function(e){
      var media = e.target.closest && e.target.closest('[data-pcard-media]');
      if(media) show(media, 0);
    }, true);
  }

  // Touch: tap zones.
  document.addEventListener('click', function(e){
    var prev = e.target.closest && e.target.closest('[data-pcard-prev]');
    var next = e.target.closest && e.target.closest('[data-pcard-next]');
    if(!prev && !next) return;
    e.preventDefault();
    e.stopPropagation();
    var media = (prev || next).closest('[data-pcard-media]');
    if(!media) return;
    media.classList.add('is-touched');
    step(media, prev ? -1 : 1);
  });

  // Touch: horizontal swipe. Only hijacks clearly horizontal gestures so
  // vertical page scrolling and rail scrolling stay untouched.
  var sx = 0, sy = 0, tracking = null, moved = false;
  document.addEventListener('touchstart', function(e){
    var media = e.target.closest && e.target.closest('[data-pcard-media]');
    if(!media || slidesOf(media).length < 2) { tracking = null; return; }
    tracking = media; moved = false;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive:true });

  document.addEventListener('touchmove', function(e){
    if(!tracking) return;
    var dx = e.touches[0].clientX - sx;
    var dy = e.touches[0].clientY - sy;
    if(!moved && Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5){
      moved = true;
      tracking.classList.add('is-touched');
      step(tracking, dx < 0 ? 1 : -1);
    }
  }, { passive:true });

  document.addEventListener('touchend', function(){
    if(tracking && moved){
      var t = tracking;
      setTimeout(function(){ t.classList.remove('is-touched'); }, 1800);
    }
    tracking = null;
  }, { passive:true });
})();
